const contact = {
    eyebrow: 'יצירת קשר',
    contact: 'בואו נבנה משהו',
    description: 'אשמח לשוחח על תפקידים בתחום ה-AI, על בעיות מעניינות, או על שיתוף פעולה במשהו ששווה לבנות. אני קורא כל הודעה.',
    getInTouch: 'שליחת הודעה',
};

export default contact;
